import { useEffect, useState } from 'react';
import Api from '../services/Api';

export const codeLabel = item => `${item.name} [${item.code}]`;

export const cityLabel = city => `${city.name}, ${city.country.name} [${city.code}]`;

// Loads `endpoint` once and maps its rows to { label, value } options for ModalBase selects
export const useSelectOptions = (endpoint, toLabel = codeLabel) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    Api.get(endpoint).then((response) => {
      if (response.status === 200) {
        setOptions(response.data.data.map(item => ({
          label: toLabel(item),
          value: item.id,
        })));
      }
    });
  }, [endpoint]);
  return options;
};

export const namesOf = items => (items && items.length > 0 ? items.map(item => item.name).join(', ') : undefined);
